/*=========================================================================================
  File Name: moduleTheoryRatingManagement.js
  Description: Receipt Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleSlipperyRatingManagementState.js'
import mutations from './moduleSlipperyRatingManagementMutations.js'
import actions from './moduleSlipperyRatingManagementActions.js'
import getters from './moduleSlipperyRatingManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}